import(/* webpackMode: "eager" */ "/vercel/path0/src/components/automatic-calculation/index.tsx")